let _initProto, _initClass, _init_value, _init_extra_value, _init_label, _init_extra_label, _init_placeholder, _init_extra_placeholder, _init_disabled, _init_extra_disabled, _init_selectionMode, _init_extra_selectionMode, _init_shouldCloseOnSelect, _init_extra_shouldCloseOnSelect, _init_changeEvent, _init_extra_changeEvent, _init_rootTarget, _init_extra_rootTarget;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop, query } from "@ecopages/radiant";
import { findAssociatedLabel, syncFieldLabel } from "../shared/field-label";
import { ListboxPopoverBehavior } from "../shared/listbox-popover-behavior";
import { parseMultiValue, serializeMultiValue } from "../shared/multi-value";
let _RuiSelect;
class RuiSelect extends RadiantElement {
  static {
    ({
      e: [_init_value, _init_extra_value, _init_label, _init_extra_label, _init_placeholder, _init_extra_placeholder, _init_disabled, _init_extra_disabled, _init_selectionMode, _init_extra_selectionMode, _init_shouldCloseOnSelect, _init_extra_shouldCloseOnSelect, _init_changeEvent, _init_extra_changeEvent, _init_rootTarget, _init_extra_rootTarget, _initProto],
      c: [_RuiSelect, _initClass]
    } = _applyDecs(this, [customElement("rui-select")], [[prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "value"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "placeholder"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [prop({
      type: String,
      attribute: "selection-mode",
      defaultValue: "single"
    }), 0, "selectionMode"], [prop({
      type: Boolean,
      attribute: "should-close-on-select"
    }), 0, "shouldCloseOnSelect"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [query({
      ref: "root"
    }), 0, "rootTarget"], [onUpdated(["value", "label", "placeholder", "disabled", "selectionMode", "shouldCloseOnSelect"]), 2, "onPropsUpdated"], [onEvent({
      selector: "[data-select-trigger], [data-select-toggle]",
      type: "click"
    }), 2, "onTriggerClick"], [onEvent({
      selector: "[data-select-trigger]",
      type: "keydown",
      options: {
        capture: true
      }
    }), 2, "onTriggerKeydown"], [onEvent({
      selector: "[data-select-listbox] [data-autocomplete-input]",
      type: "keydown",
      options: {
        capture: true
      }
    }), 2, "onSearchKeydown"], [onEvent({
      selector: "[data-select-listbox] [data-autocomplete-input]",
      type: "input"
    }), 2, "onSearchInput"], [onEvent({
      selector: "[data-select-value] rui-tag-group",
      type: "rui-remove"
    }), 2, "onTagRemove"], [onEvent({
      selector: "[data-select-value] [data-tag]",
      type: "click"
    }), 2, "onTagClick"], [onEvent({
      selector: '[data-select-listbox] [role="option"]',
      type: "pointerover"
    }), 2, "onOptionPointerOver"], [onEvent({
      selector: '[data-select-listbox] [role="option"]',
      type: "mousedown"
    }), 2, "onOptionMouseDown"], [onEvent({
      selector: '[data-select-listbox] [role="option"]',
      type: "click"
    }), 2, "onOptionClick"], [onEvent({
      ref: "root",
      type: "focusout"
    }), 2, "onFocusOut"], [onEvent({
      document: true,
      type: "pointerdown"
    }), 2, "onDocumentPointerDown"]], 0, void 0, RadiantElement));
  }
  constructor(...args) {
    super(...args);
    _init_extra_rootTarget(this);
  }
  value = (_initProto(this), _init_value(this));
  label = (_init_extra_value(this), _init_label(this));
  placeholder = (_init_extra_label(this), _init_placeholder(this));
  disabled = (_init_extra_placeholder(this), _init_disabled(this));
  selectionMode = (_init_extra_disabled(this), _init_selectionMode(this));
  shouldCloseOnSelect = (_init_extra_selectionMode(this), _init_shouldCloseOnSelect(this));
  changeEvent = (_init_extra_shouldCloseOnSelect(this), _init_changeEvent(this));
  open = (_init_extra_changeEvent(this), false);
  uid = Math.random().toString(36).slice(2, 9);
  listboxBehavior = new ListboxPopoverBehavior({
    getAnchor: () => this.rootTarget,
    getFloating: () => this.getListboxPopup(),
    getOpen: () => this.open,
    getOptions: () => this.getOptions(),
    getActiveDescendantHost: () => this.getActiveDescendantHost(),
    getOptionIdPrefix: () => `rui-select-option-${this.uid}`
  });
  rootTarget = _init_rootTarget(this);
  get listboxId() {
    return `rui-select-list-${this.uid}`;
  }
  get triggerId() {
    return `rui-select-trigger-${this.uid}`;
  }
  isMultiple() {
    return this.selectionMode === "multiple";
  }
  closesOnSelect() {
    if (this.shouldCloseOnSelect != null) {
      return this.shouldCloseOnSelect;
    }
    return !this.isMultiple();
  }
  getSelectedValues() {
    if (!this.value) {
      return [];
    }
    return parseMultiValue(this.value);
  }
  setSelectedValues(values) {
    this.value = serializeMultiValue(values);
  }
  getSearchInput() {
    return this.querySelector("[data-select-listbox] [data-autocomplete-input]");
  }
  hasSearchInput() {
    return this.getSearchInput() != null;
  }
  /** Element that receives `aria-activedescendant` while the popup is open. */
  getActiveDescendantHost() {
    if (this.open && this.hasSearchInput()) {
      return this.getSearchInput();
    }
    return this.getTrigger();
  }
  resetSearchFilter() {
    const search = this.getSearchInput();
    if (!search || search.value === "") {
      return;
    }
    search.value = "";
    search.dispatchEvent(new Event("input", {
      bubbles: true
    }));
  }
  syncSearchInput() {
    const search = this.getSearchInput();
    const trigger = this.getTrigger();
    const listbox = this.getListbox();
    if (!search || !listbox || !trigger) {
      return;
    }
    if (this.open) {
      search.setAttribute("role", "combobox");
      search.setAttribute("aria-autocomplete", "list");
      search.setAttribute("aria-expanded", "true");
      search.setAttribute("aria-controls", this.listboxId);
      trigger.removeAttribute("aria-activedescendant");
      return;
    }
    search.removeAttribute("role");
    search.removeAttribute("aria-autocomplete");
    search.removeAttribute("aria-expanded");
    search.removeAttribute("aria-controls");
    search.removeAttribute("aria-activedescendant");
  }
  focusPopupInput() {
    queueMicrotask(() => {
      this.getSearchInput()?.focus();
    });
  }
  /**
   * Resolves the multi-select chip host inside the value slot.
   *
   * @remarks
   * During Storybook/SSR upgrade, `querySelector` can return the host before
   * `rui-tag-group` is defined — treat that as absent until `setItems` exists.
   */
  getTagGroup() {
    const tagGroup = this.querySelector("[data-select-value] rui-tag-group");
    if (!tagGroup || typeof tagGroup.setItems !== "function") {
      return null;
    }
    return tagGroup;
  }
  hasTagGroup() {
    return this.getTagGroup() != null;
  }
  syncTagGroup() {
    const tagGroup = this.getTagGroup();
    const valueElement = this.getValueElement();
    if (!tagGroup || !valueElement) {
      return;
    }
    const selected = this.getSelectedValues();
    const items = selected.flatMap(value => {
      const option = this.getOptions().find(item => this.getOptionValue(item) === value);
      return option ? [{
        value,
        label: this.getOptionLabel(option)
      }] : [];
    });
    tagGroup.embedded = true;
    tagGroup.setItems(items);
    tagGroup.value = this.value;
    this.syncTagGroupPlaceholder(valueElement, selected.length);
  }
  syncTagGroupPlaceholder(valueElement, selectedCount) {
    let placeholder = valueElement.querySelector("[data-select-placeholder]");
    if (!this.placeholder) {
      placeholder?.remove();
      return;
    }
    if (!placeholder) {
      placeholder = document.createElement("span");
      placeholder.setAttribute("data-select-placeholder", "true");
      valueElement.insertBefore(placeholder, valueElement.firstChild);
    }
    placeholder.textContent = this.placeholder;
    placeholder.hidden = selectedCount > 0;
    valueElement.toggleAttribute("data-placeholder", selectedCount === 0);
  }
  removeSelectedValue(value) {
    const selected = new Set(this.getSelectedValues());
    if (!selected.has(value)) {
      return;
    }
    selected.delete(value);
    this.setSelectedValues([...selected]);
    this.syncValueDisplay();
    this.syncOptionSelection();
    this.syncTagGroup();
    this.changeEvent.emit({
      value: this.value
    });
  }
  getTrigger() {
    return this.querySelector("[data-select-trigger]");
  }
  getToggle() {
    return this.querySelector("[data-select-toggle]");
  }
  getValueElement() {
    return this.querySelector("[data-select-value]");
  }
  getListboxPopup() {
    return this.querySelector("[data-select-listbox]");
  }
  getListbox() {
    const host = this.querySelector("rui-listbox");
    if (host) {
      return host.querySelector('[role="listbox"]');
    }
    return this.getListboxPopup();
  }
  getListboxHost() {
    return this.querySelector("rui-listbox");
  }
  getOptions() {
    const listbox = this.getListbox();
    if (!listbox) {
      return [];
    }
    return Array.from(listbox.querySelectorAll('[role="option"]'));
  }
  getOptionLabel(option) {
    return option.getAttribute("data-label") || option.textContent?.trim() || "";
  }
  getOptionValue(option) {
    return option.getAttribute("data-value") || this.getOptionLabel(option);
  }
  ensureOptionIds() {
    this.listboxBehavior.ensureOptionIds();
  }
  getAccessibleName() {
    const labelElement = findAssociatedLabel(this);
    return labelElement?.textContent?.trim() || this.label || "Options";
  }
  syncLabel() {
    const trigger = this.getTrigger();
    syncFieldLabel(this, trigger, {
      controlId: this.triggerId,
      label: this.label,
      labelId: `rui-select-label-${this.uid}`
    });
  }
  syncTrigger() {
    const trigger = this.getTrigger();
    const listbox = this.getListbox();
    const popup = this.getListboxPopup();
    if (!trigger || !listbox) {
      return;
    }
    if (!trigger.id) {
      trigger.id = this.triggerId;
    }
    if (!listbox.id) {
      listbox.id = this.listboxId;
    }
    trigger.setAttribute("role", "combobox");
    trigger.setAttribute("aria-haspopup", "listbox");
    trigger.setAttribute("aria-autocomplete", "none");
    trigger.setAttribute("aria-expanded", String(this.open));
    trigger.setAttribute("aria-controls", this.listboxId);
    listbox.setAttribute("aria-label", this.getAccessibleName());
    if (this.isMultiple()) {
      listbox.setAttribute("aria-multiselectable", "true");
    } else {
      listbox.removeAttribute("aria-multiselectable");
    }
    if (popup) {
      popup.removeAttribute("role");
      popup.removeAttribute("aria-label");
      popup.removeAttribute("aria-multiselectable");
    }
    if (this.disabled) {
      trigger.disabled = true;
    }
    this.syncToggle();
    this.syncSearchInput();
  }
  syncToggle() {
    const toggle = this.getToggle();
    if (!toggle) {
      return;
    }
    toggle.setAttribute("aria-expanded", String(this.open));
    toggle.disabled = this.disabled;
  }
  syncListboxHost() {
    const host = this.getListboxHost();
    if (!host) {
      return;
    }
    host.embedded = true;
    if (!this.isMultiple()) {
      host.value = this.value;
    }
  }
  syncValueDisplay() {
    if (this.hasTagGroup()) {
      this.syncTagGroup();
      return;
    }
    const valueElement = this.getValueElement();
    if (!valueElement || valueElement.childElementCount > 0) {
      return;
    }
    const selected = this.getSelectedValues();
    if (selected.length === 0) {
      valueElement.textContent = "";
      valueElement.toggleAttribute("data-placeholder", true);
      if (this.placeholder) {
        valueElement.textContent = this.placeholder;
      }
      return;
    }
    valueElement.toggleAttribute("data-placeholder", false);
    if (this.isMultiple()) {
      const labels = selected.map(value => {
        const match2 = this.getOptions().find(option => this.getOptionValue(option) === value);
        return match2 ? this.getOptionLabel(match2) : value;
      });
      valueElement.textContent = labels.join(", ");
      return;
    }
    const match = this.getOptions().find(option => this.getOptionValue(option) === selected[0]);
    valueElement.textContent = match ? this.getOptionLabel(match) : selected[0];
  }
  syncOptionSelection() {
    const selected = new Set(this.getSelectedValues());
    for (const option of this.getOptions()) {
      const value = this.getOptionValue(option);
      const isSelected = selected.has(value);
      option.setAttribute("aria-selected", String(isSelected));
    }
  }
  setOpen(next, options = {}) {
    const activate = options.activate ?? "none";
    this.open = next;
    const trigger = this.getTrigger();
    const popup = this.getListboxPopup();
    if (!trigger || !popup) {
      return;
    }
    trigger.setAttribute("aria-expanded", String(next));
    popup.toggleAttribute("hidden", !next);
    if (!next) {
      this.listboxBehavior.clearActiveOption();
      this.resetSearchFilter();
      this.syncSearchInput();
      this.listboxBehavior.syncPopoverPosition();
      return;
    }
    this.ensureOptionIds();
    this.syncSearchInput();
    this.listboxBehavior.syncPopoverPosition();
    if (this.hasSearchInput()) {
      this.focusPopupInput();
    }
    if (activate === "first") {
      const visible = this.listboxBehavior.getVisibleOptions();
      this.listboxBehavior.setActiveOption(visible.length ? 0 : -1);
      return;
    }
    if (activate === "last") {
      const visible = this.listboxBehavior.getVisibleOptions();
      this.listboxBehavior.setActiveOption(visible.length ? visible.length - 1 : -1);
      return;
    }
    this.listboxBehavior.clearActiveOption();
  }
  selectOption(option) {
    if (option.getAttribute("aria-disabled") === "true") {
      return;
    }
    const optionValue = this.getOptionValue(option);
    if (this.isMultiple()) {
      const selected = new Set(this.getSelectedValues());
      if (selected.has(optionValue)) {
        selected.delete(optionValue);
      } else {
        selected.add(optionValue);
      }
      this.setSelectedValues([...selected]);
    } else {
      this.value = optionValue;
    }
    this.syncValueDisplay();
    this.syncOptionSelection();
    this.changeEvent.emit({
      value: this.value
    });
    if (this.closesOnSelect()) {
      this.resetSearchFilter();
      this.setOpen(false);
      this.getTrigger()?.focus();
    }
  }
  handleListboxKeydown(event2) {
    this.listboxBehavior.handleKeydown(event2, {
      isOpen: this.open,
      canUseSpace: !this.hasSearchInput(),
      closesOnTab: this.closesOnSelect(),
      enterWhenClosed: "open",
      enterWithoutActive: "ignore",
      onOpen: (activation = "none") => this.setOpen(true, {
        activate: activation
      }),
      onClose: reason => {
        this.setOpen(false);
        if (reason === "arrow" || reason === "escape") {
          this.getTrigger()?.focus();
        }
      },
      onSelectActive: () => {
        const option = this.listboxBehavior.getVisibleOptions()[this.listboxBehavior.activeOptionIndex];
        if (option) {
          this.selectOption(option);
        }
      }
    });
  }
  handleTriggerKeydown(event2) {
    this.handleListboxKeydown(event2);
  }
  initialize() {
    this.ensureOptionIds();
    this.syncLabel();
    this.syncTrigger();
    this.syncListboxHost();
    this.syncValueDisplay();
    this.syncOptionSelection();
    this.setOpen(false);
  }
  onConnected() {
    this.initialize();
  }
  disconnectedCallback() {
    this.listboxBehavior.destroy();
    super.disconnectedCallback();
  }
  onPropsUpdated() {
    this.syncLabel();
    this.syncTrigger();
    this.syncListboxHost();
    this.syncValueDisplay();
    this.syncOptionSelection();
  }
  onTriggerClick(event2) {
    event2.preventDefault();
    const trigger = this.getTrigger();
    if (!trigger || trigger.disabled) {
      return;
    }
    if (this.open) {
      this.setOpen(false);
    } else {
      this.setOpen(true);
    }
    if (this.open && this.hasSearchInput()) {
      this.focusPopupInput();
      return;
    }
    trigger.focus();
  }
  onTriggerKeydown(event2) {
    this.handleTriggerKeydown(event2);
  }
  onSearchKeydown(event2) {
    this.handleListboxKeydown(event2);
  }
  onSearchInput() {
    if (!this.open) {
      return;
    }
    this.listboxBehavior.clearActiveOption();
  }
  onTagRemove(event2) {
    const detail = event2.detail;
    if (!detail?.value) {
      return;
    }
    this.removeSelectedValue(detail.value);
  }
  onTagClick(event2) {
    const target = event2.target;
    if (target.closest("[data-tag-remove]")) {
      return;
    }
    event2.stopPropagation();
  }
  onOptionPointerOver(event2) {
    if (!this.open) {
      return;
    }
    const option = event2.target.closest('[role="option"]');
    if (!option || option.getAttribute("aria-disabled") === "true" || option.hidden) {
      return;
    }
    const visible = this.listboxBehavior.getVisibleOptions();
    const index = visible.indexOf(option);
    if (index >= 0) {
      this.listboxBehavior.setActiveOption(index);
    }
  }
  onOptionMouseDown(event2) {
    event2.preventDefault();
  }
  onOptionClick(event2) {
    const option = event2.target.closest('[role="option"]');
    if (option) {
      this.selectOption(option);
    }
  }
  onFocusOut(event2) {
    if (!this.listboxBehavior.shouldDismissFocus(event2.relatedTarget)) {
      return;
    }
    this.setOpen(false);
  }
  onDocumentPointerDown(event2) {
    if (!this.open) {
      return;
    }
    if (!this.listboxBehavior.shouldDismissPointer(event2.target)) {
      return;
    }
    this.setOpen(false);
  }
  static {
    _initClass();
  }
}
export { _RuiSelect as RuiSelect };